// @ts-nocheck
import * as React from 'react';
import './textArea.scss';
import classNames from 'classnames';

interface Props {
	value?: string;
	onChange?: any;
	onKeyDown?: any;
	size?: string;
	placeholder?: string;
}
const lineHeight = 24; // Adjust based on your font size

const TextArea = (props: Props) => {
	const { value, onChange, onKeyDown, placeholder = '', rows = 3 } = props;
	const classes: any = classNames(['text-area']);
	const height = rows * lineHeight;
	return (
		<textarea
			rows={rows}
			value={value}
			className={classes}
			onChange={onChange}
			onKeyDown={onKeyDown}
			placeholder={placeholder}
			style={{
				maxHeight: `${height}px`,
				overflowY: 'auto',
			}}
		/>
	);
};

export default TextArea;
